/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.30",
    versionName: "0.2.0-nightly.2025.6.30",
    versionChannel: "nightly",
    buildDate: "2025-06-30T00:08:16.317Z",
    commitHash: "cb48bb686f6809630efe32ded008c4dfa34d5203",
};
